import React, { FC, useMemo } from 'react';
import './ErrorPage.css';
import { useParams, useLocation } from 'react-router-dom';
import { useAppNavigation } from '@/Shared/Logic';

interface ErrorPageProps { }

const ErrorPage: FC<ErrorPageProps> = () => {
	const { code } = useParams();
	const {goToHome} = useAppNavigation();
	const searchParams = new URLSearchParams(useLocation().search);
	const reason = searchParams.get('reason') ?? "";

	const errorCode = Number(code) || 404;

	const errorConfig = useMemo(() => {
		switch (errorCode) {
			case 403:
				let message = "Vous n'avez pas les droits nécessaires pour accéder à cette ressource.";
				if (reason === 'immutable') {
					message = "Cet enregistrement système ne peut pas être modifié.";
				}
				return {
					title: "Accès refusé",
					message,
					buttonLabel: "Retour",
				};

			case 500:
				return {
					title: "Erreur interne du serveur",
					message: "Une erreur inattendue s'est produite. Veuillez réessayer plus tard.",
					buttonLabel: "Recharger la page",
				};

			case 404:
			default:
				return {
					title: "Page introuvable",
					message: "Désolé, la page que vous recherchez n'existe pas ou a été déplacée.",
					buttonLabel: "Retour à l'accueil",
				};
		}
	}, [errorCode]);

	return (
		<div className="ErrorPage" data-testid="ErrorPage">
			<div className="error-content">
				<h1 className="error-code">{errorCode}</h1>
				<h2 className="error-title">{errorConfig.title}</h2>
				<p className="error-message">{errorConfig.message}</p>


				<button
					className="error-button"
					onClick={
						() => errorCode === 500
							? window.location.reload()
							: goToHome()
					}>
					{errorConfig.buttonLabel}
				</button>

			</div>
		</div>
	);
}

export default ErrorPage;
